import { getKeyCaseInsensitive } from '~/utils'
import { APIError, handleAPIError } from './APIError'
import axios from './axios'

const bshgenAPI = async (endpoint, settings) => {
  let {
    headers = {},
    method = 'GET',
    query,
    data,
    files,
    ...rest
  } = settings ?? {}
  if (!headers?.cache && method.toUpperCase() === 'GET') {
    headers.cache = 'no-store'
  }
  if (files?.length) {
    headers['content-type'] = 'multipart/form-data'
    const fd = new FormData()
    if (data) {
      for (const key in data) {
        fd.append(key, data[key])
      }
    }
    files.forEach((file) => fd.append(`files[]`, file))
    data = fd
  }
  if (!getKeyCaseInsensitive(headers, 'content-type')) {
    headers['content-type'] = 'application/json'
  }
  let url = `/api/${endpoint}`
  try {
    const response = await axios({
      url,
      method,
      headers,
      params: query,
      data,
      ...rest,
    })
    const result = response.data
    if (response.status < 400) {
      return result
    }
    throw new APIError('API Error', response.status, result)
  } catch (err) {
    // throw handleAPIError(err)
    handleAPIError(err)
  }
}

export default bshgenAPI
